<template>
  <div class="bottom">
    <!-- 商品列表入口 -->
    <!-- <div class="bottom__bag global_pointer" @click.stop="openGoods">
      <img class="bottom__bag-logo" v-if="cert.img" :src="cert.img" />
      <div v-if="Number(goodLength) > 0" :class="['bottom__bag-badge', Number(goodLength) > 99 ? 'big' : '']">
        {{ goodLength }}
      </div>
    </div> -->

    <!-- <div @click.stop="$router.push('../download')" v-if="liveStatus !== 4" class="bottom__send bottom__send_box">{{ $t('message.room.bottomDownloadTip') }}</div> -->
    <div v-if="liveStatus === 4" class="bottom__send"></div>
    <!-- <div
      v-else-if="!userInfo"
      class="bottom__send bottom__send_box"
      @click="tologin"
    ></div> -->
    <div v-else class="bottom__send">
      <input
        ref="inputElement"
        :placeholder="$t('message.room.chatPlaceHolder')"
        maxlength="150"
        v-model="comment"
        type="text"
        @keyup.enter="submit"
        @input="inputValidate"
        @focus="onfocus"
      />
    </div>

    <!-- <img
      @click.stop="toCart"
      :src="require('@/assets/imgs/room/cart.png')"
      class="bottom__cart global_pointer"
    />
    <img
      @click.stop="showShare"
      :src="require('@/assets/imgs/room/share.png')"
      class="bottom__share global_pointer"
    /> -->
  </div>
</template>

<script>
import api from '@/api/api_list.js'
export default {
  data() {
    return {
      comment: "",
      userInfo: null,
      bannedText: {
        zh: '',
        en: ''
      }
    };
  },
  props: {
    goodLength: {
      type: [Number, String],
      default: 0,
    },
    cert: {
      type: Object,
      default: () => ({
        attestation: 0,
        attestationStr: "",
        img: "",
      }),
    },
    liveStatus: {
      type: Number,
      default: 1,
    },
    lanLabel: {
      type: [Number, String],
      default: 1,
    },
  },
  created() {
    this.userInfo = this.$storage.get("user_info") || null;
    this.getConfig()
  },
  methods: {
    onfocus() {
      this.userInfo = this.$storage.get("user_info") || null;
      if (!this.userInfo) {
        this.$refs.inputElement.blur();
        this.$isLogin(
          function () {
            this.$refs.inputElement.focus();
          }.bind(this)
        );
      }
    },
    toCart() {
      this.$isLogin(
        function () {
          this.$shareGuide.open(); // 打开引导下载弹层
          // this.$emit("showCart");
        }.bind(this)
      );
    },
    showShare() {
      this.$isLogin(
        function () {
          this.$emit("showShare");
        }.bind(this)
      );
    },
    openGoods() {
      if (Number(this.goodLength) > 0) {
        this.$emit("showGoodsList");
      }
    },
    // 获取禁言提示语
    async getConfig() {
        try {
            const { result } = await api.get_list_config({
                dictType: 'RunScreenMute'
            })
            if (result && result.length) {
                result.forEach(item => {
                    if (item.dictCode === 'run-screen-mute-zh') {
                        this.bannedText.zh = item.dictName
                    } else {
                        this.bannedText.en = item.dictName
                    }
                })
            }
        } catch (err) {
            console.log(err)
        }
    },
    async submit() {
        try {
            const {result} = await api.check_msg_auth({
                liveId: this.$route.params.room_id
            });
            if (!result.haveAuth) {
                const bannedText = this.$isZh ? this.bannedText.zh : this.bannedText.en
                this.$toast(bannedText, {duration: 5000})
            }
            let str = this.comment;
            if (str.length > 150 || str.length < 1) {
                return this.$toast.bottom(this.$t("message.room.commentLimit"));
            }
            this.comment = "";
            this.$emit("sendText", str);
        } catch (error) {
            console.log(error)
        }
    },
    inputValidate() {
      if (this.lanLabel == 3) {
        this.comment = this.comment.replace(/[\u0391-\uFFE5]/g, "");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bottom {
  box-sizing: border-box;
  padding: 0 12px;
  display: flex;
  align-items: center;
  &__bag {
    width: 46px;
    height: 46px;
    margin-right: 10px;
    border: 2px solid #fff;
    border-radius: 50%;
    position: relative;
    &-logo {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    &-cert {
      width: 100%;
      height: 13px;
      line-height: 13px;
      text-align: center;
      background: #39d2d6;
      border-radius: 7.5px;
      position: absolute;
      left: 0;
      bottom: 0;
      font-size: 9px;
      font-weight: 600;
      color: #ffffff;
    }
    &-badge {
      position: absolute;
      right: -5px;
      top: 0;
      display: inline-block;
      box-sizing: border-box;
      // padding: 0 6px;
      height: 18px;
      line-height: 18px;
      min-width: 18px;
      background: #fa5151;
      border-radius: 18px;
      font-size: 10px;
      font-weight: 600;
      color: #ffffff;
      font-family: PingFangSC-Semibold;
      &.big{
        padding: 0 3px;
        right: -8px;
      }
    }
  }
  &__send {
    flex: 1;
    height: 36px;
    line-height: 36px;
    display: flex;
      // background: white;
    > input {
      border: none;
      outline: none;
      // background: rgb(47, 47, 47);
      background: white;
      border-radius: 20px;
      font-size: 12px;
      color: #C2C3C4;
      flex: 1;
      height: 100%;
      padding: 0 20px;
      // opacity: 0.5;
    }
    &_box {
      background: rgb(47, 47, 47);
      border-radius: 20px;
      font-size: 12px;
      color: #ffffff;
      opacity: 0.5;
    }
  }
  &__cart,
  &__share {
    width: 36px;
    height: 36px;
    margin-left: 10px;
    
  }
}
</style>
